<template>
    <v-card-actions class="d-flex pa-0 ma-0 transparent" width="100%">
        <v-btn class="flex-grow-1 pa-0 ma-0 timelineItemText theme-green-background theme-title theme-border-inverse" min-height="42px" tile depressed @click="approve">
            <v-icon class="mr-2">mdi-check</v-icon>
            Elfogadás
        </v-btn>
        <v-btn class="flex-grow-1 pa-0 ma-0 timelineItemText theme-red-background theme-title theme-border-inverse" min-height="42px" tile depressed @click="reject">
            <v-icon class="mr-2">mdi-close</v-icon>
            Elutasítás
        </v-btn>
    </v-card-actions>
</template>

<script>
    import eventBus from '@/eventBus';
    import CONSTANTS from '@/constants';

    export default {
        name: 'TimelineDmrActions',
        props: {
            item: Object
        },
        methods: {
            reject: function() {
                eventBus.$emit(CONSTANTS.DMR.REJECT_MODAL, this.item);
            },
            approve: function() {
                eventBus.$emit(CONSTANTS.DMR.APPROVE, this.item);
            },
        }
    }
</script>

<style scoped>
    .v-btn {
        border-style: solid;
        border-width: 1px;
    }

    .timelineItemText {
        font-size: 12px;
        font-stretch: condensed;
        border-top: 0 !important;
    }
</style>

<style>
    .timelineItemText + .timelineItemText {
        border-left-width: 0 !important;
    }
</style>
